import React from "react";
import ServicesDesktopView from "../desktopServices";
import { useMediaQuery, useTheme } from "@mui/material";
import PeriodicServiceOverview from "./overview";
import BlogCarousel from "../common/Blogs";
import FAQ from "../common/Faq";
import SeoInfo from "../../../SeoInfo";

const standardservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSE AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC CABIN FILTER CLEAN",
  "DIESEL/FUEL FILTER CLEAN",
  "COOLANT TOP UP",
  "BATTERY WATER TOP-UP",
  "WIPER FLUID TOP-UP",
  "BRAKE/CLUTCH FLUID TOP-UP",
  "FRONT & REAR BRAKES SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
  "FREE VEHICLE DROP",
];

const periodicservices1 = [
  "HASSLE-FREE PICK/DROP",
  "COMPLETE DIAGNOSIS AND SCANNING",
  "ENGINE OIL CHANGE",
  "OIL FILTER CHANGE",
  "AIR FILTER CHANGE",
  "AC FILTER CHANGE",
  "DIESEL/FILTER CHANGE",
  "COOLANT TOP UP",
  "BATTERY TOP-UP",
  "WIPER FLUID TOP-UP",
  "BRAKE/CLUTCH FLUID TOP-UP",
  "GEAR/TRANSMISSION OIL TOP UP",
  "FRONT& REAR BRAKE PAD SERVICE",
  "SPARK PLUGS SERVICE",
  "SUSPENSION CHECK-UP",
  "RADIATOR AIR WAND",
  "WHEEL ALIGNMENT AND BALANCING",
  "TIRE ROTATION",
  "INTERIOR VACUUM",
  "THROTTLE BODY WASH",
];

const faqs = [
  {
    question: "Why should I choose Go Clutch for my car servicing?",
    answer:
      "Go Clutch provides professional, reliable, and affordable car servicing that prioritizes your convenience and satisfaction. Our team consists of highly skilled technicians who use quality parts and advanced tools to ensure your car is serviced to the highest standards.",
  },
  {
    question: "Can I book my service online with Go Clutch?",
    answer:
      "Yes, you can easily book a service appointment on our website, making it quick and convenient to schedule a time that suits you.",
  },
  {
    question: "Does Go Clutch use high-quality engine oil for car servicing?",
    answer:
      "Yes! At Go Clutch, we use Mobil Synthetic engine oil for all our engine servicing needs. Mobil Synthetic is known for its high performance, longevity, and ability to provide superior protection for your engine. This helps your car run more efficiently and keeps your engine in excellent condition for longer",
  },
  {
    question: "How long does a quick service take at Go Clutch?",
    answer:
      "Our quick service is designed to be efficient and convenient, taking approximately 2 hours to complete. This allows you to get back on the road with minimal downtime while ensuring your car receives the necessary care and attention.",
  },
  {
    question:
      "Do you offer on-site service, or do I have to bring my car to your workshop?",
    answer:
      "For your convenience, Go Clutch offers both options. We provide a pick-up and drop-off service for busy clients, or you can bring your car directly to our workshop. Our flexible options make car servicing hassle-free.",
  },
];

const blogsData = [
  {
    id: 1,
    title: "How to Maintain Your Car?",
    description: "Best practices for car maintenance.",
    link: "https://goclutch.in/car-service-in-gachibowli/",
    image: "https://i.ibb.co/0BygF6Z/blog-1.jpg",
  },
  {
    id: 2,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-services-in-hyderabad-2/",
    image: "https://i.ibb.co/FH31tMZ/blog-2.png",
  },
  {
    id: 3,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-service-in-hyderabad/",
    image: "https://i.ibb.co/tCs427X/blog-3.jpg",
  },
  {
    id: 4,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-services-in-kukatpally/",
    image: "https://i.ibb.co/kJ3ss3S/blog-4.jpg",
  },
  {
    id: 5,
    title: "Top 5 Car Services You Should Know",
    description: "Essential car services.",
    link: "https://goclutch.in/car-service-in-pragati-nagar/",
    image: "https://i.ibb.co/6HqQVFg/blog-5.jpg",
  },
];

const PeriodicService = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <SeoInfo
        title="Best Car Repairs & Mechanical Car Service in Hyderabd |Go Clutch"
        description="From minor fixes to major car services, Go Clutch ensures top performance with expert car repairs. Reliable, affordable & high-quality Car Mechaics—Book now!"
      />
      <PeriodicServiceOverview />
      <ServicesDesktopView
        title="Periodic Car"
        standardServices={standardservices1}
        premiumServices={periodicservices1}
        standardPrice={1799.0}
        premiumPrice={3599.0}
        standardImage="/serviceIcons/periodic/StandardService.svg"
        premiumImage="/serviceIcons/periodic/PremiumService.svg"
      />
      <BlogCarousel blogsData={blogsData} />
      <FAQ faqs={faqs} />
    </>
  );
};

export default PeriodicService;
